import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { faqs } from "../data/content";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-peach px-4 py-14" aria-labelledby="faq-title" data-id="element-51" data-mp="1lc20peakr5rp">
      <div className="mx-auto max-w-4xl" data-id="element-52" data-mp="1gdqt7a7r57cn">
        <h2 id="faq-title" className="text-center font-heading text-2xl font-bold uppercase" data-id="element-53" data-mp="1gauq77h1rshc">Frequently asked questions</h2>
        <div className="mt-8 divide-y divide-brand/20 rounded-lg bg-white" data-id="element-54" data-mp="291mms620yj57">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-55" data-mp="240fc9z8hz5uu" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left font-heading text-sm font-semibold" data-id="element-56" data-mp="1z372alxi684o">
                  {f.q}
                  <ChevronDownIcon className={`h-4 w-4 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-57" data-mp="nnqs7mgdgef2" />
                </button>
                <AnimatePresence initial={false} data-id="element-58" data-mp="uhao64rjn8wh">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-59" data-mp="ueofg1sx2nco">
                      <p className="px-5 pb-4 text-sm leading-relaxed text-ink-muted" data-id="element-60" data-mp="3syo9a4fteoy8">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}